"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyHometownMapWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbyHometownMapWindowModule = _interopRequireDefault(require("./LobbyHometownMapWindow.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LobbyHometownMapWindow(_ref) {
  var _ref$map = _ref.map,
      map = _ref$map === void 0 ? "SRF" : _ref$map,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyHometownMapWindowModule.default.window, _LobbyHometownMapWindowModule.default[map], className),
    style: style
  });
}